import { createMutationHelper } from '@utils/swr'
import { type ECommerceCancelSubscriptionRequest } from '../types/apiRequest'
import { type ECommerceApis } from '../types/apis'

const { useMutation } = createMutationHelper<ECommerceApis['delete']['cancelSubscription'], never, ECommerceCancelSubscriptionRequest>({
  client: 'eCommerce',
  key: '/orders/:id/subscription',
  fetcher: (_url, { client, arg }) => {
    const { id } = arg
    if (!id) {
      throw new Error('id is required')
    }
    return client.delete(`/orders/${id}/subscription`)
  },
})

export const useApiECommerceCancelSubscription = useMutation
